<template>
  <!--
      作者：luoyiming
      时间：2019-10-26
      描述：商品管理-商品添加
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="180px">
      <!--基础信息-->
      <Basic></Basic>



      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">发布</el-button>

      </div>
    </el-form>
  </div>
</template>

<script>
import LotteryApi from '@/api/lottery.js';
import Basic from './part/Basic.vue';

export default {
  components: {
    /*基础信息*/
    Basic

  },
  data() {
    return {
      /*是否正在加载*/
      loading: false,
      /*form表单数据*/
      form: {
        model: {
          prize_name:'',
          /*奖品图片*/
          image: [],
          /*奖品类型*/
          type: 10,
          /*奖品排序*/
          sort: 1,
          prize_num:0,
          is_status:10
        },


        /*是否锁住*/
        isSpecLocked: false
      }
    };
  },
  provide: function () {
    return {
      form: this.form
    }
  },
  created() {



  },
  methods: {



    /*提交*/
    onSubmit: function() {
      let self = this;
      let params = self.form.model;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;

          LotteryApi.prizeAdd(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '添加成功',
                type: 'success'
              });
              self.$router.push('/plus/lottery/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },



    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }

  }
};
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/lottery/prize/add.vue